import React from 'react';
import performanceStatsImg7 from "../../../../assets/performanceStats7.png";
import officials from "../../../../assets/officials.png";
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
const GameInfo = () => {
  const playersReducer = useSelector((state) => state?.playersReducer);
  const matchData = playersReducer?.matchData;
  const eventId = localStorage.getItem('eventID')

  const selectedGroupCodes = JSON.parse(localStorage.getItem('selectedGroupCodes'));
  const selectedEventsOptions = localStorage.getItem("selectedEventsOptions");
  const eventsOptions = JSON.parse(selectedEventsOptions);
  const eventTitle = (id) => {
    const event = eventsOptions.find((data) => data.value.split(" ")[0] === id);
    return event ? event.label : null;
  };


  const performanceStatsData = [
    {
      _id: "01",
      design: "Rosters",
      title: "Web overlay",
      image: performanceStatsImg7,
      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/7B.html?id=`,
    },
    {
      _id: "08",
      design: "Officials",
      title: "Web overlay",
      image: officials,

      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/8.html?id=`,
    },
    {
      _id: "02",
      design: "Sponsors",
      title: "Web overlay",
      image: '',

      link: `${process.env.REACT_APP_OL_API_ROOT}` + `/o/s/7B.html?id=`,
    }



  ];
  const handleCopyClick = (link, id) => {
    const textarea = document.createElement('textarea');
    textarea.value = link + id;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    toast.success('Copied to clipboard!');
  };

  const selectEvent = useSelector((state) => state?.settingReducer?.selectEvent)


  return (
    <div>

      {
        selectedGroupCodes && selectedGroupCodes.map((groupCode) => (
          <div key={groupCode} className='flex flex-col gap-6 relative'>
            <h2 className='pt-5 text-left font-bebas text-2xl pl-2'>
              Group Code: {groupCode}
            </h2>
            {
              eventsOptions[groupCode].slice().reverse().map((event, index) =>
                <div className="flex flex-col gap-6">
                  <h2 className='pt-5 text-left font-bebas text-2xl pl-2'>{event.label} {/* Render the correct event property */} </h2>
                  {performanceStatsData.map((data, i) => (
                    <div className="border-[1px] border-[#E8E8E8] rounded-md flex flex-col md:flex-row justify-between items-center" key={i}>
                      <div className="border-r-[1px] border-[#E8E8E8] max-w-[675px] w-full">
                        <p className="font-bebas text-[#4A4A4A] text-2xl py-4 px-6">
                          {data?.design}
                        </p>
                        <div className="py-4 px-6 flex flex-col gap-2 border-t-[1px] border-[#E8E8E8]">
                          <p className="font-bebas block text-[#4A4A4A] text-2xl ">
                            {data?.title}
                          </p>
                          <p className="text-[#2F2B77] block font-montserrat font-medium text-base break-all">
                            {data.link}{event.eventCode}  {/* Render the correct event value */}
                          </p>
                          <button onClick={() => handleCopyClick(data.link, event.eventCode)} className="max-w-16 w-full h-8 rounded bg-primary flex justify-center items-center text-white font-bebas">
                            copy
                          </button>
                        </div>
                      </div>
                      <div className="flex justify-center items-center max-w-full md:max-w-[480px] w-full py-[18px] md:py-0 border-t-[1px] border-[#E8E8E8] md:border-none">
                        {data?.image && (
                          <img
                            className="max-w-[240px] w-full h-[172px] object-contain rounded-md"
                            src={data?.image}
                            alt="scoreboardImg"
                          />
                        )}
                      </div>
                    </div>
                  ))}

                </div>
              )
            }
          </div>
        ))
      }


    </div>
  );
};

export default GameInfo;